import React from 'react';
import {
  BackgroundExportStatus,
  BackgroundExportTypes,
} from 'further-types/background-exports';
import DownloadTray from './DownloadTray';
import { CalendarTime } from 'utils';

interface DownloadTrayContainerProps {
  iconColor?: string;
  borderColor?: string;
  backgroundExports: Array<{
    _id: string;
    exportType: BackgroundExportTypes;
    status: BackgroundExportStatus;
    createdAt?: CalendarTime;
    downloaded: boolean;
    additionalLabel?: string;
  }>;
  downloadBackgroundExport: (exportId: string) => void;
  deleteBackgroundExport: (exportId: string) => void;
  retryBackgroundExport?: (exportId: string) => void;
  acknowledgeBackgroundExports: () => void;
  Heading?: React.ReactNode;
}

const DownloadTrayContainer: React.FC<DownloadTrayContainerProps> = ({
  iconColor,
  borderColor,
  backgroundExports,
  downloadBackgroundExport,
  deleteBackgroundExport,
  retryBackgroundExport,
  acknowledgeBackgroundExports,
  Heading,
}) => {
  return (
    <DownloadTray
      iconColor={iconColor}
      borderColor={borderColor}
      backgroundExports={backgroundExports}
      downloadBackgroundExport={downloadBackgroundExport}
      deleteBackgroundExport={deleteBackgroundExport}
      retryBackgroundExport={retryBackgroundExport}
      acknowledgeBackgroundExports={acknowledgeBackgroundExports}
      Heading={Heading}
    />
  );
};

export default DownloadTrayContainer;
